import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const ExpandHeightIcon = createIcon({
  displayName: 'ExpandHeightIcon',
  viewBox: '0 0 24 24',
  path: (
    <g fill='currentColor'>
      <rect x='2.5' y='2.4' width='19' height='2.6' rx='1.3' />
      <rect x='2.5' y='19' width='19' height='2.6' rx='1.3' />
      <path d='M12 6.4 16.4 11.3H7.6L12 6.4Z' />
      <path d='M12 17.6 7.6 12.7h8.8L12 17.6Z' />
    </g>
  ),
});
